import React, { useEffect, useState } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import "./VersionAddAndUpdate.css";
import {
  fetchAllClientsVersionStart,
  updateClientVersionStart,
  addClientVersionStart
} from "store/actions";

function VersionAddAndUpdate(props) {
  useEffect(() => {
    props.fetchAllClientsVersionStart(0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [versionStats, setVersionStats] = useState({
    productName: "",
    versionNumber: "",
    setupName: "",
    releaseDate: new Date().toLocaleDateString("en-CA")
  });

  const handleUpdateChange = e => {
    const productName = e.target.value;
    const selectedProduct = props.versionInfo.data.filter(
      pro => pro.product_name === productName
    );

    setVersionStats({
      productName: selectedProduct[0].product_name,
      versionNumber: selectedProduct[0].version_no,
      setupName: selectedProduct[0].setup_name
    });
  };

  // eslint-disable-next-line no-extend-native
  Date.prototype.toShortFormat = function() {
    let monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ];

    let day = String(this.getDate()).padStart(2, "0");

    let monthIndex = this.getMonth();
    let monthName = monthNames[monthIndex];

    let year = this.getFullYear();

    return `${day} ${monthName} ${year}`;
  };

  const handleUpdateSubmit = e => {
    props.updateClientVersionStart({
      product_name: document.getElementById("updateProductName").value,
      version_no: document.getElementById("updateVersionNumber").value,
      setup_name: document.getElementById("updateSetupName").value,
      release_date: new Date(
        document.getElementById("updateReleaseDate").value
      ).toShortFormat()
    });
  };

  const handleAddSubmit = e => {
    props.addClientVersionStart({
      product_name: document.getElementById("addProductName").value,
      version_no: document.getElementById("addVersionNumber").value,
      setup_name: document.getElementById("addSetupName").value,
      release_date: new Date(
        document.getElementById("addReleaseDate").value
      ).toShortFormat()
    });
  };

  return (
    <React.Fragment>
      <form id="versionForm" onSubmit={e => handleUpdateSubmit(e)}>
        <ul>
          <li>
            <label htmlFor="name">Product Name : </label>
            <select
              style={{ WebkitAppearance: "auto", MozAppearance: "auto" }}
              onChange={e => handleUpdateChange(e)}
              defaultValue={
                props.versionInfo && props.versionInfo.data[0].productName
              }
              id="updateProductName"
            >
              {props.versionInfo &&
                props.versionInfo.data.map(val => (
                  <option value={val.product_name} key={val.product_name}>
                    {val.product_name}
                  </option>
                ))}
            </select>
          </li>
          <li>
            <label htmlFor="versionNumber">Version Number : </label>
            <input
              type="text"
              id="updateVersionNumber"
              defaultValue={
                versionStats.versionNumber ||
                (props.versionInfo && props.versionInfo.data[0].version_no)
              }
              required
            />
          </li>
          <li>
            <label htmlFor="releaseDate">Release Date : </label>
            <input
              type="date"
              id="updateReleaseDate"
              defaultValue={new Date().toLocaleDateString("en-CA")}
              required
            />
          </li>
          <li>
            <label htmlFor="setupName">Setup Name : </label>
            <input
              type="text"
              id="updateSetupName"
              defaultValue={
                versionStats.setupName ||
                (props.versionInfo && props.versionInfo.data[0].setup_name)
              }
              required
            />
          </li>
          <li>
            <label />
            <input type="submit" value="Update" />
          </li>
        </ul>
      </form>
      <form id="versionForm" onSubmit={e => handleAddSubmit(e)}>
        <ul>
          <li>
            <label htmlFor="name">Product Name : </label>
            <input type="text" id="addProductName" required />
          </li>
          <li>
            <label htmlFor="versionNumber">Version Number : </label>
            <input type="text" id="addVersionNumber" required />
          </li>
          <li>
            <label htmlFor="releaseDate">Release Date : </label>
            <input
              type="date"
              id="addReleaseDate"
              value={new Date().toLocaleDateString("en-CA")}
              required
            />
          </li>
          <li>
            <label htmlFor="setupName">Setup Name : </label>
            <input type="text" id="addSetupName" required />
          </li>
          <li>
            <label />
            <input type="submit" value="Add" />
          </li>
        </ul>
      </form>
    </React.Fragment>
  );
}

function mapStateToProps(state) {
  return {
    versionInfo: state.auth.versionInfo
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      fetchAllClientsVersionStart,
      updateClientVersionStart,
      addClientVersionStart
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(VersionAddAndUpdate);
